import { $nocobaseProxy } from ".";

export type FreezeApplicationState = "new" | "in_work" | "clarification" | "complete";

export interface FreezeApplication {
  id: number;
  reason: string;
  date_ranges_text?: string;
  state: FreezeApplicationState;
  ticket_id?: string;
  ticket_title?: string;
  manager_comment?: string;
  branch?: Array<{
    id: number;
    name: string;
    id_1c: string;
  }>;
  documents?: Array<{
    id: number;
    title: string;
    url: string;
    filename: string;
  }>;
  createdAt: string;
  updatedAt: string;
  createdById: number;
}

export interface CreateFreezeApplicationData {
  reason: string;
  date_ranges_text?: string;
  state?: string;
  branch?: number;
  documents?: number[];
  ticket_id?: string;
  ticket_title?: string;
}

interface FreezeApplicationsListResponse {
  data: FreezeApplication[];
  meta: {
    count: number;
    page: number;
    pageSize: number;
    totalPage: number;
  };
}

interface FreezeApplicationResponse {
  data: FreezeApplication;
}

export async function createFreezeApplication(
  _phone: string,
  data: CreateFreezeApplicationData,
  clubId?: string
) {
  return $nocobaseProxy.post<FreezeApplicationResponse>(
    "/freeze_applications:create",
    { ...data, state: data.state || "new" },
    {
      headers: clubId ? { "X-Club-Id": clubId } : undefined,
    }
  );
}

export async function getFreezeApplications(
  _phone: string,
  params?: { page?: number; pageSize?: number; clubId?: string }
) {
  return $nocobaseProxy.get<FreezeApplicationsListResponse>("/freeze_applications:list", {
    params: {
      page: params?.page || 1,
      pageSize: params?.pageSize || 20,
      appends: "branch,documents",
    },
    headers: params?.clubId ? { "X-Club-Id": params.clubId } : undefined,
  });
}

export async function uploadAttachment(_phone: string, file: File) {
  const formData = new FormData();
  formData.append("file", file);

  return $nocobaseProxy.post<{ data: { id: number; url: string } }>(
    "/attachments:create",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
}

export async function addDocumentsToApplication(
  _phone: string,
  applicationId: number,
  documentIds: number[]
) {
  return $nocobaseProxy.post<FreezeApplicationResponse>(
    `/freeze_applications:update?filterByTk=${applicationId}`,
    { documents: documentIds }
  );
}

export interface UpdateFreezeApplicationData {
  reason?: string;
  date_ranges_text?: string;
  state?: FreezeApplicationState;
  documents?: number[];
}

export async function updateFreezeApplication(
  _phone: string,
  applicationId: number,
  data: UpdateFreezeApplicationData
) {
  return $nocobaseProxy.post<FreezeApplicationResponse>(
    `/freeze_applications:update?filterByTk=${applicationId}`,
    data
  );
}
